import React from 'react'
import { useTranslation } from 'react-i18next'

const LogsTable = ({ logs }) => {
    const { t } = useTranslation();
    // const formattedDate = moment(timeZone).format('MMMM DD YYYY, hh:mm A');
    const renderTableHeader = React.useCallback(() => {

        return (
            <tr>
                <th className="col-1">
                    <span>{t("table.date", { defaultValue: "Date" })}</span>
                </th>
                <th className="col-1">
                    {t("appointmentLogs.time", { defaultValue: "Time" })}
                </th>
                <th className="col-3">
                    {t("appointmentLogs.event", { defaultValue: "Event" })}
                </th>
                <th className="col-2">
                    {t("appointmentLogs.user", { defaultValue: "User" })}
                </th>
                <th className="col-5">
                    {t("appointmentLogs.notes", { defaultValue: "Notes" })}
                </th>
            </tr>
        )
    }, [t])


    const renderTableContent = React.useCallback((item) => {
        return (
            <LogItem item={item} key={item?.id} />
        )
    }, []);

    return (
        <div className='table_responsive'>
            <table className="table">
                <thead className="text-primary">
                    {renderTableHeader()}
                </thead>
                <tbody>
                    {
                        logs && logs?.map(item => renderTableContent(item))
                    }
                </tbody>
            </table>
        </div>
    )
}

const LogItem = ({ item }) => {

    return (

        <tr>
            <td className='col-2'>
                {item?.date}
            </td>
            <td className='col-2'>
                {item?.time}
            </td>
            <td className='col-2'>
                {item?.event}
            </td>
            <td className='col-2'>
                {item?.user?.name}
            </td>
            <td className='col-4'>
                {item?.notes}
            </td>
        </tr>
    )
}
export default LogsTable